import { useTheme } from "@/theme/ThemeProvider";
import { FloatingLabelListPicker } from "@/ui/components/FloatingLabelListPicker";
import {
  PRIVACY_PROVISION_OPTIONS,
  type PrivacyProvisionKind,
} from "@/ui/finder/finderMode";
import { Text, View } from "react-native";

/** Nur die Art der Bereitstellung. Kennt die Checkbox nicht. */
export function FinderPrivacyProvision({
  value,
  onChange,
  optional = true,
  focusRequest = 0,
}: {
  value: PrivacyProvisionKind | null;
  onChange: (value: PrivacyProvisionKind | null) => void;
  optional?: boolean;
  /** Steigt beim Speicherversuch ohne Art, damit der Picker den Fokus erhält. */
  focusRequest?: number;
}) {
  const { theme } = useTheme();

  return (
    <View
      style={{
        gap: theme.space.sm,
        padding: theme.space.sm,
        borderRadius: theme.radius.md,
        borderWidth: 1,
        borderColor: theme.color.border,
        backgroundColor: theme.color.surface,
      }}
    >
      <Text
        style={{
          color: theme.color.text,
          fontWeight: "700",
          fontSize: theme.fontSize.body,
        }}
      >
        {optional ? "Art der Bereitstellung (optional)" : "Art der Bereitstellung"}
      </Text>
      <FloatingLabelListPicker
        label="Art der Bereitstellung"
        options={PRIVACY_PROVISION_OPTIONS}
        value={value}
        required={!optional}
        focusRequest={focusRequest}
        onChange={(next) => onChange((next as PrivacyProvisionKind | null) ?? null)}
        placeholder="Wie wurde die Information bereitgestellt?"
      />
    </View>
  );
}
